module.exports = __webpack_public_path__ + "img/Tim Rodloff.427dc92a.jpg";